import { Grid, Tab, Tabs } from "@mui/material";
import { Link, Route, Switch, useRouteMatch } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { MDBox } from "../../../Component/Common/Components/MDBox";
import { MDTypography } from "../../../Component/Common/Components/MDTypography";
import { ScorecardAtom } from "../../../State/Scorecard.Atom";
import { CommitteeMembers } from "./Members/CommitteeMembersTable";
import { CommitteeMinutesPage } from "./Minutes/CommitteeMinutesTable";

export const CommitteeBase = () => {
    const scorecard = useRecoilValue(ScorecardAtom);

    const routes = [
        "/ee/scorecard/" + scorecard.scorecardId + "/committee/Members",
        "/ee/scorecard/" + scorecard.scorecardId + "/committee/Minutes",
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;

    return (

        <>
            <MDBox style={{ padding: "10px" }}>
                <MDTypography variant='h4' fontWeight='bold' style={{ paddingBottom: "15px" }}>
                    Employment Equity Committee
                </MDTypography>
            </MDBox>

            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        <Tab label="Members" value={routes[0]} to={routes[0]} component={Link} />
                        <Tab label="Minutes" value={routes[1]} to={routes[1]} component={Link} />
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={3}>
                    <Switch>
                        <Route path={routes[0]}>
                            <CommitteeMembers />
                        </Route>
                        <Route path={routes[1]}>
                            <CommitteeMinutesPage />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>);
}